export const data = [
  {
    glAccount: "Pond Cleaning",
    budget: 20000,
    committed: 15000,
    actuals: 15000,
    children: [
      { Month: "January", Budget: "$0", Committed: "$2000", Actuals: "$2000" },
      { Month: "February", Budget: "$0", Committed: "$2000", Actuals: "$2000" },
      { Month: "March", Budget: "$0", Committed: "$0", Actuals: "$0" },
    ],
  },
  {
    glAccount: "Road Cleaning",
    budget: 30000,
    committed: 10000,
    actuals: 8000,
    children: [
      { Month: "January", Budget: "$0", Committed: "$5000", Actuals: "$4000" },
      { Month: "February", Budget: "$0", Committed: "$5000", Actuals: "$4000" },
    ],
  },
];

export const GL_ACCOUNT = "glMasterId";
export const PAYMENT_DATE_RANGE = "paymentDateRang";
export const POSTED_DATE_RANGE = "postedDateRang";
export const APPROVED_BY = "approvedBy";
export const POSTING_YEAR = "postingYear";
export const BUDGET_YEAR = "budgetYear";
